<form [formGroup]="editForm">

    <section class="autocomplete">
        <app-autocomplete [control]="editForm.get('client')" [list]="clients"
            label="repository.licenses.edit.client.label" errorMsg="repository.licenses.edit.client.errorMessage">
        </app-autocomplete>
    </section>


    <section class="inlineInputs">
        <mat-form-field>
            <mat-label>{{ 'repository.licenses.edit.startDate.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="startDatePicker" (click)="startDatePicker.open()"
                (focus)="startDatePicker.open()" formControlName="startDate">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            <mat-error>{{ 'repository.licenses.edit.startDate.errorMessage' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'repository.licenses.edit.endDate.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="endDatePicker" (click)="endDatePicker.open()"
                (focus)="endDatePicker.open()" formControlName="endDate">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
    </section>
    <div *ngIf="conflictWithActualLicenses">
        <mat-error>{{ 'repository.licenses.edit.conflictWithOtherLicense' | translate }}</mat-error>
    </div>

    <section class="inlineInputs">
        <mat-form-field>
            <mat-label>{{ 'repository.licenses.edit.monthlyPrice.label' | translate }}</mat-label>
            <input type="number" matInput formControlName="monthlyPrice">
            <mat-error>{{ 'repository.licenses.edit.monthlyPrice.errorMessage' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'repository.licenses.edit.maxOrdersPerMonth.label' | translate }}</mat-label>
            <input type="number" matInput formControlName="maxOrdersPerMonth">
            <mat-error>{{ 'repository.licenses.edit.maxOrdersPerMonth.errorMessage' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'repository.licenses.edit.pricePerExtraOrder.label' | translate }}</mat-label>
            <input type="number" matInput formControlName="pricePerExtraOrder">
            <mat-error>{{ 'repository.licenses.edit.pricePerExtraOrder.errorMessage' | translate }}</mat-error>
        </mat-form-field>
    </section>

    <section>
        <mat-form-field>
            <mat-label>{{ 'repository.licenses.edit.comment.label' | translate }}</mat-label>
            <textarea matInput rows="5" formControlName="comment"></textarea>
        </mat-form-field>
    </section>

    <app-validate-and-cancel (submitEvent)="onEndForm($event)" [editForm]="editForm"
        [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>